import { FC, ReactNode, useCallback } from 'react';
import { UrlObject } from 'url';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import TransportMediumIcon from './TransportMediumIcon';
import { TransportMedium } from './types';

interface ICardLandingProps {
  title: string;
  info: string;
  path: string | UrlObject;
  transportMedium?: TransportMedium;
  children?: ReactNode;
  actions?: ReactNode;
}

export const CardLanding: FC<ICardLandingProps> = (props) => {
  const { title, info, path, transportMedium, children, actions } = props;
  const location = useLocation();
  const [searchParams] = useSearchParams();

  // Function to store the current section before navigating to detail pages
  const storeCurrentSection = useCallback(() => {
    // Check if we're on the landing page with a section parameter
    if (location.pathname === '/' && searchParams.has('section')) {
      const currentSection = searchParams.get('section');
      if (currentSection) {
        localStorage.setItem('lastSectionName', currentSection);
      }
    }
  }, [location.pathname, searchParams]);

  return (
    <div className='relative h-full'>
      <Link
        to={path}
        onClick={storeCurrentSection}
        className='relative h-full bg-white border border-neutral-20 rounded-8 flex flex-col transition-all duration-300 hover:border-primary hover:shadow-[0px_4px_7px_0px_rgba(0,153,43,0.01),0px_2px_0px_0px_rgba(0,153,43,0.5)] shadow-[0px_4px_7px_0px_rgba(102,102,102,0.05),0px_3px_0px_0px_#DFDFDF]'
      >
        <div className='px-12 xl:px-16 pt-20 xl:pt-20 pb-20 xl:pb-30 flex items-center gap-12'>
          {transportMedium && (
            <div className='w-30 xl:w-36 h-30 xl:h-36 rounded-full bg-[#F5F6FA] flex items-center justify-center'>
              <TransportMediumIcon medium={transportMedium} iconColor='#9F9F9F' />
            </div>
          )}
          <div className='flex-1 flex flex-col w-full pr-[40px] xl:pr-[32px]'>
            <h3 className='text-14 xl:text-16 font-medium'>{title}</h3>
            <p className='text-12 text-neutral-60 truncate w-full'>{info}</p>
          </div>
        </div>
        {children && <div className='mt-auto bg-[#FAFBFF] border-t border-[#EBEDF1] py-12 xl:py-12 px-16 flex items-center gap-4 rounded-b-8'>{children}</div>}
      </Link>
      {actions && <div className='absolute top-25 right-12'>{actions}</div>}
    </div>
  );
};
